import React from 'react'
import styles from './styles.module.scss'
import OptionCard from './option-card/option-card'
import Merchant from '@/src/interfaces/merchant/merchant'

interface Props {
    option: Merchant.DeliveryOptions
}

export default function DeliveryOptions({ option }: Props) {
    return (
        <div className={styles.contentOptions}>
            <h2 className={`${styles.title} font-lg`}>Opções de entrega</h2>
            <div className={styles.options}>
                {option.deliveryEnabled && <OptionCard option="delivery" />}
                {option.takeoutEnabled && <OptionCard option='takeOut' />}
                {option.indoorEnabled && <OptionCard option="dineIn" />}
            </div>
        </div>
    )
}
